/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPlaylistPlay = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 10.759 20.985 16 12 21.241zm2 3.482v3.518L17.015 16zM10 15v2l-8 .001V15zm0-4v2l-8 .001V11zm12-3.999v2H2v-2zM22 3v2L2 5.001V3z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgPlaylistPlay as PlaylistPlay };
